import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card card-custom" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "h6 mb-5 text-fprimary" }
const _hoisted_6 = { class: "row mx-auto" }
const _hoisted_7 = { class: "col-sm-2 border bg-gray-100 d-flex align-items-center" }
const _hoisted_8 = { class: "col-sm-5 border" }
const _hoisted_9 = { class: "col-sm-1 border bg-gray-100 d-flex align-items-center" }
const _hoisted_10 = { class: "col-sm-4 border" }
const _hoisted_11 = { class: "row mx-auto" }
const _hoisted_12 = { class: "col-sm-2 border bg-gray-100 d-flex align-items-center" }
const _hoisted_13 = { class: "col-sm-10 border" }
const _hoisted_14 = { class: "row mx-auto" }
const _hoisted_15 = { class: "col-sm-2 border bg-gray-100 d-flex align-items-center" }
const _hoisted_16 = { class: "col-sm-4 border" }
const _hoisted_17 = { class: "col-sm-2 border bg-gray-100 d-flex align-items-center" }
const _hoisted_18 = { class: "col-sm-4 border" }
const _hoisted_19 = { class: "row mx-auto" }
const _hoisted_20 = { class: "col-sm-2 border bg-gray-100 d-flex align-items-center" }
const _hoisted_21 = { class: "col-sm-4 border" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "Código del país", -1)
const _hoisted_23 = { class: "col-sm-3 border" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "#1", -1)
const _hoisted_25 = { class: "col-sm-3 border" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "#2", -1)
const _hoisted_27 = { class: "row mx-auto" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 border bg-gray-100 d-flex align-items-center" }, "E-mail", -1)
const _hoisted_29 = { class: "col-sm-10 border" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("hr", { class: "border border-black border-1 opacity-100" }, null, -1)
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-sm-12" }
const _hoisted_33 = { class: "h6 mb-5 text-fprimary" }
const _hoisted_34 = { class: "row mx-auto" }
const _hoisted_35 = { class: "col-sm-6 border" }
const _hoisted_36 = { class: "mt-2" }
const _hoisted_37 = { class: "col-sm-6 border" }
const _hoisted_38 = { class: "mt-2" }
const _hoisted_39 = { class: "row mx-auto" }
const _hoisted_40 = { class: "col-sm-2 border bg-gray-100 d-flex align-items-center" }
const _hoisted_41 = { class: "col-sm-4 border" }
const _hoisted_42 = { class: "col-sm-2 border bg-gray-100 d-flex align-items-center" }
const _hoisted_43 = { class: "col-sm-4 border" }
const _hoisted_44 = { class: "row mx-auto" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 border bg-gray-100 d-flex align-items-center" }, "Teléfonos", -1)
const _hoisted_46 = { class: "col-sm-4 border" }
const _hoisted_47 = { class: "col-sm-3 border" }
const _hoisted_48 = { class: "col-sm-3 border" }
const _hoisted_49 = { class: "row mx-auto" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 border bg-gray-100 d-flex align-items-center" }, "E-mail", -1)
const _hoisted_51 = { class: "col-sm-10 border" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("hr", { class: "border border-black border-1 opacity-75" }, null, -1)
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-sm-12" }
const _hoisted_55 = { class: "h6 fw-bold mb-5 text-black opacity-75" }
const _hoisted_56 = { class: "table table-bordered border" }
const _hoisted_57 = { class: "bg-info text-center p-3 text-white" }
const _hoisted_58 = {
  class: "border fw-bold align-middle py-2 px-2",
  scope: "col",
  rowspan: "2"
}
const _hoisted_59 = {
  class: "border fw-bold",
  scope: "col",
  colspan: "2"
}
const _hoisted_60 = { class: "border fw-bolder align-middle" }
const _hoisted_61 = { class: "border" }
const _hoisted_62 = {
  key: 0,
  class: "bi bi-check-lg h1 text-primary"
}
const _hoisted_63 = {
  key: 1,
  class: "bi bi-x-lg h3 text-fsecondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref: "formQRef",
        model: _ctx.formQ,
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.t("nusf1")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t("nusf")), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                prop: "idinstitution",
                class: "my-4",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formQ.idinstitution,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formQ.idinstitution) = $event)),
                    size: "small",
                    placeholder: "Institución",
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: _ctx.formQ.idinstitution,
                        label: _ctx.formQ.business
                      }, null, 8, ["value", "label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t("country")), 1),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_form_item, {
                prop: "country",
                class: "my-4",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formQ.country,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formQ.country) = $event)),
                    size: "small",
                    filterable: "",
                    placeholder: "Pais/Región",
                    class: "w-100",
                    disabled: true
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCountry, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `lr-${item.idcountry}`,
                          label: `${item.idcountry} - ${item.name}`,
                          value: item.idcountry
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t("address")), 1),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_form_item, {
                prop: "address",
                class: "my-5",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.address,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formQ.address) = $event)),
                    size: "small",
                    maxlength: "100"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t("city")), 1),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_form_item, {
                prop: "city",
                class: "my-4",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.city,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formQ.city) = $event)),
                    size: "small",
                    maxlength: "50"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t("postalCode")), 1),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_el_form_item, {
                prop: "postalcode",
                class: "my-4",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.postalcode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formQ.postalcode) = $event)),
                    size: "small",
                    maxlength: "50"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("telephones")), 1),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_el_form_item, {
                prop: "phonecode",
                class: "mt-0 mb-4",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formQ.phonecode,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formQ.phonecode) = $event)),
                    size: "small",
                    filterable: "",
                    placeholder: "Seleccione"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCountry, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.idcountry,
                          label: `${item.name} ${item.postalcode}`,
                          value: item.idcountry
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_el_form_item, {
                prop: "phone1",
                class: "mt-0 mb-5",
                rules: [
                            { required: true, message: 'Requerido', trigger: ['blur', 'change'] },
                            { validator: _ctx.validatePhoneNumber, trigger: ['blur', 'change'] }
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.phone1,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formQ.phone1) = $event)),
                    size: "small",
                    maxlength: "20"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["rules"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_el_form_item, {
                prop: "phone2",
                class: "mt-0 mb-5",
                rules: [
                            { required: true, message: 'Requerido', trigger: ['blur', 'change'] },
                            { validator: _ctx.validatePhoneNumber, trigger: ['blur', 'change'] }
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.phone2,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formQ.phone2) = $event)),
                    size: "small",
                    maxlength: "20"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_el_form_item, {
                prop: "email",
                class: "my-4",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.email,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formQ.email) = $event)),
                    size: "small",
                    maxlength: "100"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.t("ContactPerson")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("FamilyName")), 1),
              _createVNode(_component_el_form_item, {
                prop: "firstname",
                class: "mt-1 mb-4",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.firstname,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formQ.firstname) = $event)),
                    size: "small",
                    maxlength: "50"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.t("GivenName")), 1),
              _createVNode(_component_el_form_item, {
                prop: "lastname",
                class: "mt-1 mb-4",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.lastname,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formQ.lastname) = $event)),
                    size: "small",
                    maxlength: "50"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.t("gender")), 1),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_el_form_item, {
                prop: "gender",
                class: "my-4",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.formQ.gender,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formQ.gender) = $event)),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, {
                        label: 'M',
                        class: "mb-0"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Masculino")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, {
                        label: 'F',
                        class: "mb-0"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Femenino")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.t("function")), 1),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_el_form_item, {
                prop: "nfunction",
                class: "my-4",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.nfunction,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formQ.nfunction) = $event)),
                    size: "small",
                    maxlength: "50"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("label", null, _toDisplayString(_ctx.t("Countrycallingcode")), 1),
              _createVNode(_component_el_form_item, {
                prop: "cphonecode",
                class: "mt-0 mb-2",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formQ.cphonecode,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formQ.cphonecode) = $event)),
                    filterable: "",
                    placeholder: "Seleccione",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCountry, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.idcountry,
                          label: `${item.name} ${item.postalcode}`,
                          value: item.idcountry
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("label", null, _toDisplayString(_ctx.t("mobile")), 1),
              _createVNode(_component_el_form_item, {
                prop: "cphone1",
                class: "mb-5",
                rules: [
                            { required: true, message: 'Requerido', trigger: ['blur', 'change'] },
                            { validator: _ctx.validatePhoneNumber, trigger: ['blur', 'change'] }
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.cphone1,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formQ.cphone1) = $event)),
                    size: "small",
                    onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleInput('cphone1', $event))),
                    maxlength: "20"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["rules"])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("label", null, _toDisplayString(_ctx.t("oficine")), 1),
              _createVNode(_component_el_form_item, {
                prop: "cphone2",
                class: "mb-5",
                rules: [
                            { required: true, message: 'Requerido', trigger: ['blur', 'change'] },
                            { validator: _ctx.validatePhoneNumber, trigger: ['blur', 'change'] }
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.cphone2,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formQ.cphone2) = $event)),
                    size: "small",
                    maxlength: "20"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, [
              _createVNode(_component_el_form_item, {
                prop: "cemail",
                class: "my-4",
                rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formQ.cemail,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formQ.cemail) = $event)),
                    size: "small",
                    maxlength: "100"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("h3", _hoisted_55, _toDisplayString(_ctx.t("qtitle3")), 1)
            ])
          ]),
          _createElementVNode("table", _hoisted_56, [
            _createElementVNode("tr", _hoisted_57, [
              _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.t("sports")), 1),
              _createElementVNode("th", _hoisted_59, _toDisplayString(_ctx.t("qtitle4")), 1)
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formQ.athletes, (domain, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "text-center"
                }, [
                  _createElementVNode("td", _hoisted_60, _toDisplayString(domain.name), 1),
                  _createElementVNode("td", _hoisted_61, [
                    (_ctx.formQ?.mstatus == 0)
                      ? (_openBlock(), _createBlock(_component_el_switch, {
                          key: 0,
                          modelValue: domain.men,
                          "onUpdate:modelValue": ($event: any) => ((domain.men) = $event),
                          "active-value": "1",
                          "inactive-value": "0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (domain.men == 1)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_62))
                            : (_openBlock(), _createElementBlock("i", _hoisted_63))
                        ], 64))
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}